<template>
    <div class="card posting">
        <div class="card-body">
            <router-link :to="'/u/'+posting.user.username" class="avatar-image">
                <img :src="getAvatar(posting)" alt="">
            </router-link>

            <h5 class="username-display">
                <router-link :to="'/u/'+posting.user.username">{{ posting.user.username }}</router-link>
            </h5>

            <p class="posting-body" v-if="posting.body" v-text="posting.body"></p>

            <div v-if="posting.pulled_booster" class="pulled-booster-display">
                <img v-if="posting.pulled_booster.packshot_url" v-on:error="posting.pulled_booster.packshot_url = '/api/packshot/'+posting.pulled_booster.set_id" :src="posting.pulled_booster.packshot_url" class="pulled-booster-packshot" alt="booster pack image">
                <div class="pulled-cards-carousel">
                    <template v-for="card_id in posting.pulled_booster.card_ids.split(';')">
                        <img v-if="card_id.search('sve-') === -1"
                             class="pulled-card"
                             :src="'/assets/dipocaco/sets/'+card_id.split('-')[0]+'/cards_sm/'+card_id+'.png'"
                             :alt="card_id"
                             v-on:click="cardClick(card_id)"/>
                    </template>
                </div>
            </div>

            <div v-if="posting.achievement" class="posting-achievement">
                <div class="card bg-dark">
                    <div class="card-body text-light">
                        <i class="fa-solid fa-trophy"></i> <span class="achievement-message">{{ currentLocale == 'de' && posting.achievement.message_de ? posting.achievement.message_de : posting.achievement.message }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="card-footer">
            <button :class="'btn btn-sm btn-secondary float-end '+(isLikedByUser(posting) ? ' liked' : '')" v-on:click="toggleLike($event, posting)">
                {{ posting.reactions.length > 0 ? (posting.reactions.length + ' ') : '' }} <i class="fa-solid fa-thumbs-up"></i>
            </button>

            <button v-if="ownPosting" class="btn btn-sm btn-danger float-end me-2" v-on:click="deletePosting(posting)">
                <i class="fa-solid fa-trash"></i>
            </button>

            <small class="muted">
                {{ getPostingTimestamp(posting.created_at) }}
            </small>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import iziToast from "izitoast";
import UserService from "../../UserService";

export default {
    name: "SocialFeed",
    props: {
        posting: Object,
    },
    data() {
        return {
            clickedCard: null,
        }
    },
    mounted() {
        if (this.posting.pulled_booster) {
            // this.clickedCard = this.posting.pulled_booster.card_ids.split(';')[0];
        }
    },
    computed: {
        ownPosting() {
            return this.posting.user_id === this.$store.state.user.user_id;
        },
        currentLocale() {
            return this.$i18n.locale;
        }
    },
    methods: {
        getAvatar(posting) {
            return UserService.getAvatarLinkByFilename(posting.user.account.avatar.filename)
        },
        getPostingTimestamp(createdAt) {
            return moment(createdAt).fromNow()
        },
        toggleLike(event, posting) {
            axios.post('/api/social/react', {
                posting: posting.id
            }).then((response) => {
                if (response.data.isNowLiked) {
                    iziToast.success({
                        title: this.$i18n.t('social.liked'),
                        position: 'topCenter',
                    });
                }

                posting.reactions = response.data.reactions;
            })
        },
        isLikedByUser(posting) {
            return posting.reactions.find(r => r.user_id == this.$store.state.user.id) !== undefined;
        },
        cardClick(cardId) {
            this.$store.commit('updateAutoLoadCanvasCard', cardId);

            setTimeout(() => {
                $("#card-detail-view-autoload-canvas").offcanvas('toggle');
            }, 150)
        },
        deletePosting(posting) {
            let postingComponent = this;

            iziToast.question({
                timeout: 20000,
                close: false,
                overlay: true,
                displayMode: 'once',
                id: 'question',
                zindex: 999,
                message: this.$i18n.t('social.deleteConfirm'),
                position: 'center',
                buttons: [
                    [
                        '<button><b>Yes</b></button>',
                        function (instance, toast) {
                            instance.hide({transitionOut: 'fadeOut'}, toast, 'button');

                            axios.post('/api/social/posting/delete', {
                                id: posting.id,
                            }).then((response) => {
                                iziToast.success({title: this.$i18n.t('social.postingDeleted')});
                                postingComponent.$emit('postingDeleted');
                            });
                        }, true
                    ], [
                        '<button>Cancel</button>',
                        function (instance, toast) {
                            instance.hide({transitionOut: 'fadeOut'}, toast, 'button');
                        }
                    ],
                ],
                // onClosing: function(instance, toast, closedBy){
                //     console.info('Closing | closedBy: ' + closedBy);
                // },
                // onClosed: function(instance, toast, closedBy){
                //     console.info('Closed | closedBy: ' + closedBy);
                // }
            });

            this.$emit('postingDeleted');
        }
    }
}
</script>

<style scoped lang="scss">
.posting {
    margin-top: 4em;

    .avatar-image {
        vertical-align: top !important;
        display: inline-block !important;
        max-width: 7em !important;
        margin-top: -3.5em !important;
        margin-left: -2em !important;
        border-radius: 1000px !important;
        border: 5px solid black !important;
        background-color: grey !important;

        img {
            max-width: 100% !important;
        }
    }

    .username-display {
        display: inline-block;
        margin-left: 0.5em;

        a {
            text-decoration: none;
            color: initial;
        }
    }

    .posting-body {
        margin-top: 1em;
    }

    .pulled-booster-display {
        display: flex;
        $height: 15vh;

        .pulled-booster-packshot {
            height: $height;
            padding-right: 1em;
            padding-bottom: 1em;
        }

        .pulled-cards-carousel {
            white-space: nowrap;
            overflow-x: auto;
            overflow-y: hidden;
            height: $height;

            .pulled-card {
                border-radius: 3px;
                height: $height;
                width: auto;
                background-size: contain;
                background-repeat: no-repeat;
                display: inline-block;
                padding-bottom: 1em;

                &:not(:last-child) {
                    margin-right: 0.5em;
                }

                &:hover {
                    cursor: pointer;
                }
            }
        }
    }

    .posting-achievement {
        vertical-align: top;

        .fa-trophy {
            max-width: 25%;
            display: inline-block;
            font-size: 4em;
            color: goldenrod;
        }

        .achievement-message {
            padding-left: 1em;
            vertical-align: top;
            max-width: 74%;
            display: inline-block;
        }
    }

    .btn.liked {
        color: turquoise;
        background-color: #3f4142;
    }
}
</style>